import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, message, Input, Alert, Divider } from "antd";

import { req_edit_lrs_spaceInformation, req_single_people } from "../../api";
import storageUtils from "../../utils/storageUtils";
const { Search } = Input;

class SpaceModalManager extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    space: {},
    people: {},
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (item) => {
    const result = await req_edit_lrs_spaceInformation(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_search_item = async (key) => {
    // console.log(key);
    const result = await req_single_people(key, storageUtils.getUser().token);
    console.log(result);
    if (result === null) {
      message.success("查無此人");
    } else {
      this.setState({ people: result });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////
  onSearch = (value) => {
    //console.log(value);
    if (value.length > 4) {
      this.api_search_item(value);
    } else {
    }
  };

  onChange = () => {
    const { people } = this.state;
    const { Uid } = this.props.space;
    const item = {
      condition: "MANAGER",
      ConfirmorACode: people.EmployeeId,
      Uid: Uid,
    };
    //console.log(item)
    this.api_modify_item(item);
  };
  ////////////////////////////////////////////////////////////

  render() {
    const { ConfirmorACode, ConfirmorATwName, RoomCode, RoomTwName } =
      this.props.space;
    const { people } = this.state;
    return (
      <Card>
        <Alert
          message={
            <div style={{ color: "red", fontSize: "1.3em" }}>
              ({RoomCode}){RoomTwName}
            </div>
          }
          type="success"
        />
        <Divider />
        <div className="row">
          <div style={{ fontSize: "1.3em" }}>
            現任管理者：{ConfirmorATwName}({ConfirmorACode})
          </div>{" "}
          <Search
            placeholder="接任者職號"
            allowClear
            enterButton={
              <>
                <i className="fas fa-search"></i> 查詢
              </>
            }
            size="large"
            onSearch={this.onSearch}
          />
          {JSON.stringify(people) === "{}" ? (
            ""
          ) : (
            <div style={{ paddingTop: "2px", width: "100%" }}>
              <Search
                placeholder="接任者職號"
                allowClear
                enterButton={
                  <>
                    <i className="fas fa-exchange-alt"></i> 接任
                  </>
                }
                size="large"
                value={people.TwName}
                onSearch={this.onChange}
              />
            </div>
          )}
          <></>
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceModalManager);
